import { Button, Stack } from '@cast/design-system';
import { OptimizationWorkload } from '@cast/types';

import { useRestrictionsDrawer } from 'features/cluster/restrictions/_hooks/useRestrictionsDrawer';
import { RestrictionsDrawerProps } from 'features/cluster/restrictions/_hooks/useRestrictionsDrawer/types';

import { useCostReportWorkloadDetailsDrawer } from '../_hooks/useCostReportWorkloadDetailsDrawer';

type Props = {
  // Duplicated with matchingWorkload.{name,namespace,kind}; kept for restrictions flow when matchingWorkload is undefined.
  workloadName: string;
  namespace: string;
  workloadType: string;
  matchingWorkload?: OptimizationWorkload;
  restrictions: RestrictionsDrawerProps['restrictions'];
  hasRestrictions: boolean;
  isRestrictionsLoading: boolean;
};

export const WorkloadCrossLinks = ({
  workloadName,
  namespace,
  workloadType,
  matchingWorkload,
  restrictions,
  hasRestrictions,
  isRestrictionsLoading,
}: Props) => {
  const { openWorkloadDetailsDrawer } = useCostReportWorkloadDetailsDrawer();
  const { openRestrictionsDrawer } = useRestrictionsDrawer();

  const handleOpenWorkloadDetails = () => {
    if (!matchingWorkload) return;
    openWorkloadDetailsDrawer(matchingWorkload);
  };

  const handleOpenRestrictions = () => {
    openRestrictionsDrawer({
      resourceName: workloadName,
      resourceNamespace: namespace,
      resourceKind: workloadType,
      restrictions,
    });
  };

  return (
    <Stack direction="row" gap={8}>
      <Button
        testId="cost-report-restrictions-button"
        variant="secondary"
        size="sm"
        onClick={handleOpenRestrictions}
        disabled={!hasRestrictions || isRestrictionsLoading}
      >
        Restrictions
      </Button>
      <Button
        testId="cost-report-workload-details-button"
        variant="secondary"
        size="sm"
        onClick={handleOpenWorkloadDetails}
        disabled={!matchingWorkload}
      >
        Workload details
      </Button>
    </Stack>
  );
};
